export const Types = {
  // For copy & paste
  // _REQUEST: '@matches/_REQUEST',
  // _SUCCESS: '@matches/_SUCCESS',
  // _FAILURE: '@matches/_FAILURE',

  GET_MATCHES_REQUEST: '@matches/GET_MATCHES_REQUEST',
  GET_MATCHES_SUCCESS: '@matches/GET_MATCHES_SUCCESS',
  GET_MATCHES_FAILURE: '@matches/GET_MATCHES_FAILURE',

  GET_SQUADS_REQUEST: '@matches/GET_SQUADS_REQUEST',
  GET_SQUADS_SUCCESS: '@matches/GET_SQUADS_SUCCESS',
  GET_SQUADS_FAILURE: '@matches/GET_SQUADS_FAILURE',

  GET_SELECTED_MATCH_REQUEST: '@matches/GET_SELECTED_MATCH_REQUEST',
  GET_SELECTED_MATCH_SUCCESS: '@matches/GET_SELECTED_MATCH_SUCCESS',
  GET_SELECTED_MATCH_FAILURE: '@matches/GET_SELECTED_MATCH_FAILURE',

  GET_SELECTED_MATCH_STATUS_REQUEST:
    '@matches/GET_SELECTED_MATCH_STATUS_REQUEST',
  GET_SELECTED_MATCH_STATUS_SUCCESS:
    '@matches/GET_SELECTED_MATCH_STATUS_SUCCESS',
  GET_SELECTED_MATCH_STATUS_FAILURE:
    '@matches/GET_SELECTED_MATCH_STATUS_FAILURE',

  GET_SELECTED_MATCH_SCORE_REQUEST: '@matches/GET_SELECTED_MATCH_SCORE_REQUEST',
  GET_SELECTED_MATCH_SCORE_SUCCESS: '@matches/GET_SELECTED_MATCH_SCORE_SUCCESS',
  GET_SELECTED_MATCH_SCORE_FAILURE: '@matches/GET_SELECTED_MATCH_SCORE_FAILURE',

  GET_SELECTED_MATCH_REFEREES_REQUEST:
    '@matches/GET_SELECTED_MATCH_REFEREES_REQUEST',
  GET_SELECTED_MATCH_REFEREES_SUCCESS:
    '@matches/GET_SELECTED_MATCH_REFEREES_SUCCESS',
  GET_SELECTED_MATCH_REFEREES_FAILURE:
    '@matches/GET_SELECTED_REFEREES_STATUS_FAILURE',

  GET_SELECTED_MATCH_REFEREE_ASSISTANTS_REQUEST:
    '@matches/GET_SELECTED_MATCH_REFEREE_ASSISTANTS_REQUEST',
  GET_SELECTED_MATCH_REFEREE_ASSISTANTS_SUCCESS:
    '@matches/GET_SELECTED_MATCH_REFEREE_ASSISTANTS_SUCCESS',
  GET_SELECTED_MATCH_REFEREE_ASSISTANTS_FAILURE:
    '@matches/GET_SELECTED_REFEREE_ASSISTANTS_STATUS_FAILURE',

  GET_SELECTED_MATCH_KITS_REQUEST: '@matches/GET_SELECTED_MATCH_KITS_REQUEST',
  GET_SELECTED_MATCH_KITS_SUCCESS: '@matches/GET_SELECTED_MATCH_KITS_SUCCESS',
  GET_SELECTED_MATCH_KITS_FAILURE: '@matches/GET_SELECTED_MATCH_KITS_FAILURE',

  GET_SELECTED_MATCH_GRASS_STATUS_REQUEST:
    '@matches/GET_SELECTED_MATCH_GRASS_STATUS_REQUEST',
  GET_SELECTED_MATCH_GRASS_STATUS_SUCCESS:
    '@matches/GET_SELECTED_MATCH_GRASS_STATUS_SUCCESS',
  GET_SELECTED_MATCH_GRASS_STATUS_FAILURE:
    '@matches/GET_SELECTED_MATCH_GRASS_STATUS_FAILURE',

  GET_SELECTED_MATCH_LINEUP_REQUEST:
    '@matches/GET_SELECTED_MATCH_LINEUP_REQUEST',
  GET_SELECTED_MATCH_LINEUP_SUCCESS:
    '@matches/GET_SELECTED_MATCH_LINEUP_SUCCESS',
  GET_SELECTED_MATCH_LINEUP_FAILURE:
    '@matches/GET_SELECTED_MATCH_LINEUP_FAILURE',

  GET_SELECTED_MATCH_ACTS_REQUEST: '@matches/GET_SELECTED_MATCH_ACTS_REQUEST',
  GET_SELECTED_MATCH_ACTS_SUCCESS: '@matches/GET_SELECTED_MATCH_ACTS_SUCCESS',
  GET_SELECTED_MATCH_ACTS_FAILURE: '@matches/GET_SELECTED_MATCH_ACTS_FAILURE',

  GET_SELECTED_MATCH_TEAM_STATS_REQUEST:
    '@matches/GET_SELECTED_MATCH_TEAM_STATS_REQUEST',
  GET_SELECTED_MATCH_TEAM_STATS_SUCCESS:
    '@matches/GET_SELECTED_MATCH_TEAM_STATS_SUCCESS',
  GET_SELECTED_MATCH_TEAM_STATS_FAILURE:
    '@matches/GET_SELECTED_MATCH_TEAM_STATS_FAILURE',

  GET_SELECTED_MATCH_EVENTS_REQUEST:
    '@matches/GET_SELECTED_MATCH_EVENTS_REQUEST',
  GET_SELECTED_MATCH_EVENTS_SUCCESS:
    '@matches/GET_SELECTED_MATCH_EVENTS_SUCCESS',
  GET_SELECTED_MATCH_EVENTS_FAILURE:
    '@matches/GET_SELECTED_MATCH_EVENTS_FAILURE',

  GET_SELECTED_MATCH_DIRECT_STATS_REQUEST:
    '@matches/GET_SELECTED_MATCH_DIRECT_STATS_REQUEST',
  GET_SELECTED_MATCH_DIRECT_STATS_SUCCESS:
    '@matches/GET_SELECTED_MATCH_DIRECT_STATS_SUCCESS',
  GET_SELECTED_MATCH_DIRECT_STATS_FAILURE:
    '@matches/GET_SELECTED_MATCH_DIRECT_STATS_FAILURE',

  GET_SELECTED_MATCH_PUBLIC_FILES_REQUEST:
    '@matches/GET_SELECTED_MATCH_PUBLIC_FILES_REQUEST',
  GET_SELECTED_MATCH_PUBLIC_FILES_SUCCESS:
    '@matches/GET_SELECTED_MATCH_PUBLIC_FILES_SUCCESS',
  GET_SELECTED_MATCH_PUBLIC_FILES_FAILURE:
    '@matches/GET_SELECTED_MATCH_PUBLIC_FILES_FAILURE',

  GET_SELECTED_MATCH_PRIVATE_FILES_REQUEST:
    '@matches/GET_SELECTED_MATCH_PRIVATE_FILES_REQUEST',
  GET_SELECTED_MATCH_PRIVATE_FILES_SUCCESS:
    '@matches/GET_SELECTED_MATCH_PRIVATE_FILES_SUCCESS',
  GET_SELECTED_MATCH_PRIVATE_FILES_FAILURE:
    '@matches/GET_SELECTED_MATCH_PRIVATE_FILES_FAILURE',

  FLUSH_SELECTED_MATCH: '@matches/FLUSH_SELECTED_MATCH',
};

// MATCHES
export const getMatchesRequest = query => ({
  type: Types.GET_MATCHES_REQUEST,
  payload: {
    query,
  },
});

export const getMatchesSuccess = payload => ({
  type: Types.GET_MATCHES_SUCCESS,
  payload: {
    payload,
  },
});

export const getMatchesFailure = () => ({
  type: Types.GET_MATCHES_FAILURE,
});

// SQUADS
export const getSquadsRequest = (localId, visitorId) => ({
  type: Types.GET_SQUADS_REQUEST,
  payload: {
    localId,
    visitorId,
  },
});

export const getSquadsSuccess = payload => ({
  type: Types.GET_SQUADS_SUCCESS,
  payload,
});

export const getSquadsFailure = () => ({
  type: Types.GET_SQUADS_FAILURE,
});

// GET SELECTED MATCH

export const getSelectedMatchRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_SUCCESS,
  payload,
});

export const getSelectedMatchFailure = () => ({
  type: Types.GET_SELECTED_MATCH_FAILURE,
});

export const getSelectedMatchStatusRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_STATUS_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchStatusSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_STATUS_SUCCESS,
  payload,
});

export const getSelectedMatchStatusFailure = () => ({
  type: Types.GET_SELECTED_MATCH_STATUS_FAILURE,
});

export const getSelectedMatchScoreRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_SCORE_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchScoreSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_SCORE_SUCCESS,
  payload,
});

export const getSelectedMatchScoreFailure = () => ({
  type: Types.GET_SELECTED_MATCH_SCORE_FAILURE,
});

export const flushSelectedMatch = () => ({
  type: Types.FLUSH_SELECTED_MATCH,
});

// REFEREES
export const getSelectedMatchRefereesRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_REFEREES_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchRefereesSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_REFEREES_SUCCESS,
  payload,
});

export const getSelectedMatchRefereesFailure = () => ({
  type: Types.GET_SELECTED_MATCH_REFEREES_FAILURE,
});

export const getSelectedMatchRefereeAssistantsRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_REFEREE_ASSISTANTS_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchRefereeAssistantsSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_REFEREE_ASSISTANTS_SUCCESS,
  payload,
});

export const getSelectedMatchRefereeAssistantsFailure = () => ({
  type: Types.GET_SELECTED_MATCH_REFEREE_ASSISTANTS_FAILURE,
});

// KITS

export const getSelectedMatchKitsRequest = matchId => {
  return {
    type: Types.GET_SELECTED_MATCH_KITS_REQUEST,
    payload: {
      matchId,
    },
  };
};

export const getSelectedMatchKitsSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_KITS_SUCCESS,
  payload,
});

export const getSelectedMatchKitsFailure = () => ({
  type: Types.GET_SELECTED_MATCH_KITS_FAILURE,
});

// GRASS STATUS

export const getSelectedMatchGrassStatusRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_GRASS_STATUS_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchGrassStatusSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_GRASS_STATUS_SUCCESS,
  payload,
});

export const getSelectedMatchGrassStatusFailure = () => ({
  type: Types.GET_SELECTED_MATCH_GRASS_STATUS_FAILURE,
});

// LINEUP

export const getSelectedMatchLineupRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_LINEUP_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchLineupSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_LINEUP_SUCCESS,
  payload,
});

export const getSelectedMatchLineupFailure = () => ({
  type: Types.GET_SELECTED_MATCH_LINEUP_FAILURE,
});

// ACTS

export const getSelectedMatchActsRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_ACTS_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchActsSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_ACTS_SUCCESS,
  payload,
});

export const getSelectedMatchActsFailure = () => ({
  type: Types.GET_SELECTED_MATCH_ACTS_FAILURE,
});

// STATS

export const getSelectedMatchTeamStatsRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_TEAM_STATS_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchTeamStatsSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_TEAM_STATS_SUCCESS,
  payload,
});

export const getSelectedMatchTeamStatsFailure = () => ({
  type: Types.GET_SELECTED_MATCH_TEAM_STATS_FAILURE,
});

// EVENTS

export const getSelectedMatchEventsRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_EVENTS_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchEventsSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_EVENTS_SUCCESS,
  payload,
});

export const getSelectedMatchEventsFailure = () => ({
  type: Types.GET_SELECTED_MATCH_EVENTS_FAILURE,
});

// DIRECT STATS

export const getSelectedMatchDirectStatsRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_DIRECT_STATS_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchDirectStatsSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_DIRECT_STATS_SUCCESS,
  payload,
});

export const getSelectedMatchDirectStatsFailure = () => ({
  type: Types.GET_SELECTED_MATCH_DIRECT_STATS_FAILURE,
});

export const getSelectedMatchPublicFilesRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_PUBLIC_FILES_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchPublicFilesSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_PUBLIC_FILES_SUCCESS,
  payload,
});

export const getSelectedMatchPublicFilesFailure = () => ({
  type: Types.GET_SELECTED_MATCH_PUBLIC_FILES_FAILURE,
});

export const getSelectedMatchPrivateFilesRequest = matchId => ({
  type: Types.GET_SELECTED_MATCH_PRIVATE_FILES_REQUEST,
  payload: {
    matchId,
  },
});

export const getSelectedMatchPrivateFilesSuccess = payload => ({
  type: Types.GET_SELECTED_MATCH_PRIVATE_FILES_SUCCESS,
  payload,
});

export const getSelectedMatchPrivateFilesFailure = () => ({
  type: Types.GET_SELECTED_MATCH_PRIVATE_FILES_FAILURE,
});
